import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import type { MultiLang } from '../config';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';
import XoonipsListItem from './lib/XoonipsListItem';

interface Props {
    lang: MultiLang;
}

const XoonipsSearchByAdvancedKeyword = (props: Props) => {
    const { lang } = props;
    const location = useLocation();
    const query = useMemo(() => ItemUtil.getAdvancedSearchQueryByQuery(location.search), [location.search]);

    const searchFunc = useCallback(
        (condition: SortCondition, func: SearchCallbackFunc) => {
            ItemUtil.getListByAdvancedSearchQuery(query, condition, func);
        },
        [query]
    );

    return (
        <div className="list">
            <h3>Listing item</h3>
            <XoonipsListItem lang={lang} url={ItemUtil.getSearchByAdvancedKeywordsUrl(query)} search={searchFunc} />
        </div>
    );
};

export default XoonipsSearchByAdvancedKeyword;
